<template>
  <div>
    <div class="button" v-if="phone">
      <p>考点电话：<span>{{ phone }}</span></p>
      <p>（10:00-12:00，14:00-18:00）</p>
    </div>
    <div class="default-info" v-if="defaultInfo.phone || defaultInfo.address">
      <div v-if="defaultInfo.phone">如有疑问请联系当地分公司：<span>{{ defaultInfo.phone }}</span></div>
      <div v-if="defaultInfo.address">联系地址：{{ defaultInfo.address }}</div>
    </div>
    <div class="default-info" v-else>
      <div class="tips">
        {{ defaultInfo.default_text }}<span>{{ defaultInfo.default }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getCompanyInfo } from '../../../utils/actions'
export default {
  data () {
    return {
      defaultInfo: {}
    }
  },
  props: {
    phone: String
  },
  mounted () {
    getCompanyInfo({
      city_id: this.$store.state.cityId || '66'
    }).then((res) => {
      this.defaultInfo = res.data
    })
  }
}
</script>
<style lang="scss" scoped>
.button {
  font-size: .24rem;
  color: #19191A;
  // padding: .4rem .3rem;
  text-align: center;

  p span {
    color: #2A2AFF;
  }
}

.default-info {
  bottom: .4rem;
  left: 0;
  right: 0;
  width: 95%;
  margin: 0 auto;
  text-align: center;
  color: #19191A;
  line-height: .34rem;
  font-size: .24rem;

  div {
    span {
      color: #2A2AFF;
    }
  }

  .tips {
    text-align: center;
    font-size: .24rem;
    font-weight: 400;
    color: #19191A;
    line-height: .34rem;

    span {
      color: #2A2AFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/appointed-road-test/components/BottomLayout.vue